<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">ตำแหน่ง</span>
      <v-scroll-x-transition>
        <div style="display: flex" v-show="!positionFormShow">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            style="width: 200px; padding: 0 5px"
          ></v-text-field>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::position:create')"
            style="margin-top: 1px"
            color="primary"
            @click="handleAddPositionForm"
          >
            <v-icon small left>mdi-plus</v-icon>เพิ่มตำแหน่ง
          </v-btn>
          <v-menu min-width="200">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list nav dense>
              <v-list-item
                link
                :disabled="
                  uiCtrl &&
                  !uiCtrl.isEnable('btn:::import_data:import_csv:position:post')
                "
                @click="uploadDialog = true"
              >
                <v-list-item-icon>
                  <v-icon>mdi-import</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>นำเข้าข้อมูล</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-scroll-x-transition>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="positions"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
    </v-data-table>
    <PositionForm
      :formShow="positionFormShow"
      :formAction="positionFormAction"
      :position="position"
      :positionInit="positionInit"
      @isPositionDataChange="handlePositionFormDataChange"
      @formActionCompleted="handlePositionFormActionCompleted"
      @onReset="handlePositionFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="positionFormShow && positionFormAction === 'add'"
      z-index="0"
    ></v-overlay>
    <v-dialog v-model="dialogProgress" persistent width="320">
      <div class="pa-4 white">
        <v-progress-linear :value="progressValue" height="25">
          <strong>{{ Math.ceil(progressValue) }}%</strong>
        </v-progress-linear>
      </div>
    </v-dialog>
    <UploadDialog
      :uploadDialog="uploadDialog"
      uploadDialogTitle="นำเข้าข้อมูลตำแหน่ง"
      :downloadExampleFileImportDataUrl="exampleFileImportDataUrl"
      downloadExampleFileImportDataName="position.csv"
      @selectedFile="selectedFile"
      @handleCancelUploadDialog="handleCancelUploadDialog"
      @uploadFile="uploadFile"
    />
    <UploadDialogMessage
      :uploadDialogMessage="uploadDialogMessage"
      uploadDialogMessageTitle="นำเข้าข้อมูลตำแหน่งไม่สำเร็จ"
      :downloadFileImportDataUrl="fileImportDataUrl"
      :downloadFileImportDataName="fileImportDataName"
      @onClose="uploadDialogMessage = false"
    />
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import UploadDialog from '@/components/UploadDialog.vue'
import UploadDialogMessage from '@/components/UploadDialogMessage.vue'
import PositionForm from '@/views/position/PositionForm.vue'

export default {
  components: {
    PositionForm,
    ConfirmDialog,
    UploadDialog,
    UploadDialogMessage,
  },
  data() {
    return {
      dialogForbidden: false,
      fileImportDataUrl: '',
      fileImportDataName: '',
      dialogProgress: false,
      progressValue: 0,
      sortBy: ['position_code'],
      sortDesc: [false],
      currentFile: null,
      uploadDialog: false,
      uploadDialogMessage: false,
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: true,
      search: '',
      headers: [
        {
          text: 'รหัสตำแหน่ง',
          align: 'start',
          value: 'position_code',
          width: 150,
        },
        { text: 'ชื่อตำแหน่ง', value: 'title_th' },
        { text: 'ชื่อตำแหน่ง (อังกฤษ)', value: 'title_en' },
      ],
      positionFormShow: false,
      positionFormAction: '',
      position: {},
      positionInit: {},
      isPositionDataChange: false,
      interval: null,
      timeout: null,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    positions() {
      return this.$store.state.position.positions
    },
    exampleFileImportDataUrl() {
      return this.$store.state.download.exampleFileImportDataUrl
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'ตำแหน่ง',
        disabled: true,
      },
    ])

    this.loadData()
  },
  methods: {
    ...mapActions({
      fetchPositions: 'position/fetchPositions',
      uploadFileImportData: 'upload/uploadFileImportData',
      downloadExampleFileImportData: 'download/downloadExampleFileImportData',
      generateFileProgress: 'download/generateFileProgress',
    }),
    selectedFile(file) {
      this.currentFile = file
    },
    handleCancelUploadDialog(refs) {
      this.uploadDialog = false
      this.currentFile = null
      refs.clearableCallback()
    },
    uploadFile(refs) {
      if (this.currentFile) {
        let formData = new FormData()
        formData.append('file', this.currentFile)

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          uuid: company_uuid,
          fileType: 'position',
          formData: formData,
        }

        this.$store.state.loading = true

        this.uploadFileImportData(payload)
          .then((data) => {
            this.$store.state.loading = false
            this.uploadDialog = false
            refs.clearableCallback()

            this.progressValue = 0
            this.dialogProgress = true
            this.uploadProgress(data.job_process_uuid, data.ping_after_ms)
          })
          .catch((error) => {
            this.$store.state.loading = false
            this.uploadDialog = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      } else {
        const snackbar = {
          show: true,
          color: 'warning',
          timeout: 4000,
          message: 'ไม่ได้เลือกไฟล์ใด',
        }

        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    uploadProgress(job_process_uuid, ping_after_ms) {
      this.interval = setInterval(() => {
        this.generateFileProgress(job_process_uuid)
          .then((res) => {
            if (res.is_success) {
              this.progressValue = 100
              this.timeout = setTimeout(() => {
                this.dialogProgress = false
              }, 200)

              clearInterval(this.interval)

              if (res.resource_json?.total_fail > 0) {
                const fileUrl = res.resource_uri
                const fileName = fileUrl.split('/').pop()
                this.fileImportDataUrl = fileUrl
                this.fileImportDataName = fileName
                this.timeout = setTimeout(() => {
                  this.uploadDialogMessage = true
                }, 300)
              } else {
                this.loadData()

                this.timeout = setTimeout(() => {
                  const snackbar = {
                    show: true,
                    color: 'success',
                    timeout: 3000,
                    message: 'นำเข้าข้อมูลสำเร็จ',
                  }

                  this.$store.commit('SET_SNACKBAR', snackbar)
                }, 300)
              }
            } else {
              this.progressValue = (100 / res.total) * res.progress
            }
          })
          .catch((error) => {
            clearInterval(this.interval)
            this.dialogProgress = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)

            clearInterval(this.interval)
          })
      }, ping_after_ms)
    },
    classRowSelected(row) {
      if (this.position.position_uuid === row.position_uuid)
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::position:get')) {
        this.dialogForbidden = true
        return
      }

      if (this.position.position_uuid === row.position_uuid) {
        this.positionFormShow = false
        this.positionFormAction = ''
        this.position = {}
        this.positionInit = {}
      } else {
        this.positionFormShow = true
        this.positionFormAction = 'edit'
        this.position = { ...row }
        this.positionInit = { ...row }
      }
    },
    handleRowSelected(row) {
      if (this.isPositionDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddPositionForm() {
      this.positionFormShow = true
      this.positionFormAction = 'add'
      this.position = {}
      this.positionInit = {}
    },
    handlePositionFormDataChange(value) {
      this.isPositionDataChange = value
    },
    handlePositionFormReset(formAction) {
      if (formAction === 'edit') this.position = { ...this.positionInit }
    },
    handlePositionFormActionCompleted(formAction) {
      this.position = {}
      this.positionInit = {}
      this.positionFormShow = false
      this.positionFormAction = ''
    },
    loadData() {
      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        params: { dpc: 'position-to-list-position' },
      }
      const positions = this.fetchPositions(payload)

      const downloadExampleFileImportData = this.downloadExampleFileImportData({
        uuid: company_uuid,
        exampleFileType: 'position',
      })

      Promise.all([positions, downloadExampleFileImportData])
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.positionFormShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isPositionDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
